import './scss/main.scss'

import { createApp, ref } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
// import { createGtm } from '@gtm-support/vue-gtm'

import stores from './stores'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import { ApiClient } from './data/api'

const app = createApp(App)

const apiClient = new ApiClient()
app.provide('apiClient', apiClient)

app.use(stores)
app.use(router)
app.use(i18n)
app.use(createVuestic({ config: vuesticGlobalConfig }))

import { nextTick } from 'vue'

nextTick(async () => {
  try {
    const response = await apiClient.getMe()
    const user = ref(null)
    app.provide('user', user)
    if (!response.ok) {
      console.error('Failed to fetch user data:', response)
      router.push('/auth/login')
    } else {
      console.log('User data fetched successfully:', response.user)
      user.value = response.user
    }
    
    app.mount('#app')
  } catch (error) {
    console.error('Failed to fetch user data:', error)
    app.provide('user', null)
    router.push('/auth/login')
  }
})
